import { render, staticRenderFns } from "./TopstatsCounter.vue?vue&type=template&id=3e47c0a6&scoped=true&"
import script from "./TopstatsCounter.vue?vue&type=script&lang=ts&"
export * from "./TopstatsCounter.vue?vue&type=script&lang=ts&"
import style0 from "./TopstatsCounter.vue?vue&type=style&index=0&id=3e47c0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47c0a6",
  null
  
)

export default component.exports